import { Component, Input } from "@angular/core"

@Component({
  selector: "empty-data",
  templateUrl: "./empty-data.component.html",
  styleUrls: ["./empty-data.component.css"]
})

export class EmptyData {
  @Input("text")
  text: string = ""
}